import { Component } from '@angular/core';

@Component({
  selector: 'app-noauthorized',
  templateUrl: './noauthorized.component.html',
  styleUrls: ['./noauthorized.component.css'],
  standalone: false
})
export class NoauthorizedComponent {

}
